import { formatPln } from '../catalog/money';
import { marginText } from './CostCell';
import { bpToPct, type Totals, type Version } from './types';

/**
 * Under the table, the way the owner's PDF ends: "Podsumowanie Netto" on a warm band, then a stronger band with
 * the gross amount in bold italics. VAT and "W tym rabaty" (list price minus net) in one quiet line.
 */
export function QuoteTotals({ totals, vatBp, live, costs }: { totals: Totals; vatBp: number; live: boolean; costs?: Version['costs'] | undefined }) {
  // owner 2026-10-24 10:08: red when the cost holds estimates of shortages not rented yet, the reason on hover
  const estimated =
    costs && (costs.estimatedGrosze ?? 0) > 0
      ? `Koszt zawiera szacunek braków: ${formatPln(costs.estimatedGrosze!)} — brakujące sztuki jeszcze nie dopożyczone, liczone po średniej cen dostawców (albo Twojej cenie, gdy żaden dostawca ich nie ma). Najedź na koszt pozycji, by zobaczyć szczegóły.`
      : undefined;
  return (
    <section className="q-totals" aria-label="Sumy kosztorysu" data-feature-id="quotes.tab">
      <div className="q-band">
        <span>Podsumowanie netto</span>
        <strong className="num" data-testid="quote-net">
          {formatPln(totals.netGrosze)}
        </strong>
      </div>
      <p className="q-band-note">
        VAT {bpToPct(vatBp)}%: <span className="num">{formatPln(totals.vatGrosze)}</span>
        {totals.discountsGrosze > 0 && !live && (
          <>
            {' '}
            · w tym rabaty: <span className="num">{formatPln(totals.discountsGrosze)}</span>
          </>
        )}
        {live && <span className="q-live"> · liczone na bieżąco, jeszcze nie zapisane</span>}
      </p>
      <div className="q-band strong">
        <span>Całkowity koszt usługi brutto</span>
        <strong className="num" data-testid="quote-gross">
          {formatPln(totals.grossGrosze)}
        </strong>
      </div>
      {costs && (
        // F29: for the owner only (never in the PDF): the company's cost and what is left of the net
        <p className="q-costs" data-feature-id="quotes.costs" data-testid="quote-costs">
          Koszt:{' '}
          <span className={`num${estimated ? ' q-cost-estimated' : ''}`} title={estimated}>
            {formatPln(costs.costGrosze)}
          </span>{' '}
          · Wynik:{' '}
          <span className={`num${costs.resultGrosze < 0 ? ' neg' : ''}${estimated ? ' q-cost-estimated' : ''}`} title={estimated}>
            {formatPln(costs.resultGrosze)}
          </span>
          {costs.marginBp !== null && (
            <>
              {' '}
              · Marża: <span className="num">{marginText(costs.marginBp)}</span>
            </>
          )}
          {(costs.otherRentalsGrosze ?? 0) > 0 && (
            <span className="q-cost-other" title="Dopożyczenia wydarzenia sprzętu, którego ta wersja nie ma jako własnej pozycji">
              {' '}
              · w tym inne dopożyczenia: <span className="num">{formatPln(costs.otherRentalsGrosze!)}</span>
            </span>
          )}
        </p>
      )}
    </section>
  );
}
